/* eslint-disable */ import { assertString, memoEval, textValueComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
export const woodTextureMaterialComponents = [
    attachAdminComponent.withComponent(textValueComponent, 'name', true).withAlias('WoodTextureMaterial').attach(memoEval((self)=>[
            self.name
        ], (name)=>({
            value: name
        })), (state)=>{
        assertString(state.value);
        return {
            name: state.value
        };
    })
];

//# sourceMappingURL=wood-texture-material.js.map